import { useEffect, useState } from 'react';
import { RpcClient } from '../../../services/rpc-socket/rpcClient';
import { TLicense } from './types';
import { useRpc } from '../../../context/RpcContext';
import { useAuthContext } from '../../../context/AuthContext';
export function useLicenseApi() {
  const [license, setLicense] = useState<TLicense | null>(null);
  const { subscribe, wsOpened } = useRpc();
  const { isAuthenticated } = useAuthContext();
  useEffect(() => {
    if (!wsOpened || !isAuthenticated) return;
    // Функция для обновления лицензии
    const updateLicense = (params: TLicense) => {
      if (!params) return;
      setLicense(params);
    };
    if (!wsOpened) return;
    // Подписываемся на обновление лицензии
    RpcClient.call('subscribe', 'license' as any);

    subscribe('license', updateLicense);
  }, [wsOpened, isAuthenticated]); // Зависимость от isLicenseUpdated

  return license;
}
